import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";
import { BiTrash, BiUpload, BiChevronRight } from "react-icons/bi";
import { FcFolder, FcImageFile, FcDocument, FcFile } from "react-icons/fc";
import { Breadcrumb, Button, Modal } from "react-bootstrap";
import ErrorHandlingService from "../../../../core/service/ErrorHandlingService";
import DmsService from "../../../../core/service/DmsService";
import FileService from "../../../../core/service/FileService";
import Utils from "../../../../core/utilities/Utils";

function File({ t, file, callbackFile, deleteFile }) {
  const [showInfo, setShowInfo] = useState(false);
  const [show, setShow] = useState(false);
  const [showCheck, setShowCheck] = useState(false);
  const [deleteItem, setDeleteItem] = useState("");
  const [showRename, setShowRename] = useState(false);
  const [rename, setRename] = useState("");
  const handleRenameClose = () => setShowRename(false);
  const handleClose = () => setShow(false);

  //   document.addEventListener("contextmenu", (event) => {
  //     event.preventDefault();
  //   });
  useEffect(() => {
    document.addEventListener("click", handleClickOuter);
    return () => {
      document.removeEventListener("click", handleClickOuter);
    };
  }, []);

  const handleClick = (e, id, fileName) => {
    e.preventDefault();
    if (e.type === "contextmenu") {
      setShowInfo(!showInfo);
    } else if (e.type === "click") {
      setShowCheck(!showCheck);
      showInfo && setShowInfo(false);
    }
    if (e.detail === 2) {
      //doubleclick
      handleDownloadFile(id);
    }
  };
  const handleClickOuter = useCallback(() => setShowInfo(false), [showInfo]);
  const handleDelete = (e, item) => {
    e.preventDefault();
    setShow(true);
    setShowInfo(false);
    setDeleteItem(item);
  };
  const handleConfirm = (e) => {
    e.preventDefault();
    setShow(false);
    deleteFile(deleteItem);
  };
  const handleCheckbox = () => setShowCheck(!showCheck);

  //   const deleteFolder = (params) => {
  //     setShow(false);
  //     DmsService.deleteFolder(params)
  //       .then((response) => {})
  //       .catch((error) => {
  //         //ErrorHandlingService.handleError(error.response.status);
  //       });
  //   };
  //download File
  const handleDownloadFile = (id) => {
    FileService.downloadFile(id)
      .then((response) => {
        let fetchDataModified = `data:${response.data.mimeType};base64,${response.data.file}`;
        let link = document.createElement("a");
        link.href = fetchDataModified;
        link.download = response.data.name;
        link.click();
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleRename = (e, item) => {
    e.preventDefault();
    setRename(item);
    setShowRename(true);
    setShowInfo(false);
  };
  const handleRenameConfirm = (e) => {
    e.preventDefault();
    setShowRename(false);
  };
  const handleRenameCallback = (item) => {
    file.name = item.name;
    setShowRename(false);
  };
  const handleMouseLeave = () => {
    showInfo && setShowInfo(false);
  }
  return (
    <>
      <div
        className="Single_DMSFiles"
        onClick={(e) => handleClick(e, file.id, file.name)}
        onContextMenu={(e) => handleClick(e, file.id, file.name)}
        onMouseLeave={handleMouseLeave}
      >
        <div className="Single_DMSFiles_inner">
          <div className="Single_DMSFiles_icon">
            {(() => {
              switch (file.mimeType) {
                case "image/png":
                  return <FcImageFile />;
                case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
                  return <FcDocument />;
                default:
                  return <FcFile />;
              }
            })()}
          </div>
          <div className="S-DMSF-Title">{file.name}</div>
          {showInfo && (
            <div className="S-DMSF_info">
              <ul>
                {/* <li>
                  <Link to="#" onClick={(e) => handleRename(e, file)}>
                    {t("Rename.label")}
                  </Link>
                </li> */}
                <li>
                  <a href="#">
                    {t("Information.label")} <BiChevronRight />
                  </a>
                  <div className="Information_Folder">
                    <p>
                      {t("CreatedOn.label")} :{" "}
                      <b>{moment(file.createdDate).format("MMM DD, YYYY")}</b>
                    </p>
                    <p>
                      {t("LastModified.label")} :{" "}
                      <b>
                        {moment(file.lastModifiedDate).format("MMM DD, YYYY")}
                      </b>
                    </p>
                    {/* <p>
                      {t("NoofItems.label")} : <b>2</b>
                    </p> */}
                  </div>
                </li>
                {file.canEdit && (
                <li>
                  <Link to="#" onClick={(e) => handleDelete(e, file)}>
                    {t("Delete.label")}
                  </Link>
                </li>
                )}
              </ul>
            </div>
          )}
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>{t("ConfirmDeleteFolder.label")}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("Close.label")}
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
            {t("Confirm.label")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default withTranslation()(File);
